import {cloneDeep} from 'lodash';

const insertRow = (alldata, index, row) => {
  return [...alldata.slice(0, index), row, ...alldata.slice(index + 1)];
};

export const updateItem = (ordersProcessedData, payload, keys) => {
  const indexObject = ordersProcessedData.findIndex(
    (odr) =>
      odr[keys[0]] === payload[keys[0]] && odr[keys[1]] === payload[keys[1]]
  );
  if (indexObject !== -1) {
    const newOrdersProcessedData = cloneDeep(ordersProcessedData);
    const orderLine = {...newOrdersProcessedData[indexObject], ...payload};
    return insertRow(newOrdersProcessedData, indexObject, orderLine);
  }
  return ordersProcessedData;
};
